<template>
    <div class="page-module-wrap">
        <div class="tabs is-toggl">
            <ul class="">
                <li v-for="(item,index) in categoryList" :class="{ 'is-active': activeIndex == index }" v-on:click="onTabClick(item.type, index)">
                    <a><span>{{ item.categoryName }} </span></a>
                </li>
            </ul>
        </div>
        <div class="list-wrap">
            <div class="control  search-component">
                <div class="control">
                    <label class="label inline-block ">时间长度</label>
                    <el-date-picker
                            v-model="search.startTime"
                            type="datetime"
                            placeholder="选择开始时间">
                    </el-date-picker>
                    <span>~</span>
                    <el-date-picker
                            v-model="search.endTime"
                            type="datetime"
                            placeholder="选择结束时间">
                    </el-date-picker>
                </div>
               <div class="control  search-component">
                   <label class="label inline-block r-top">客服：</label>
                   <span class="inline-block">
                    <el-select v-model="search.userId" filterable placeholder="请选择">
                      <el-option
                              v-for="item in csList"
                              :key="item.userId"
                              :label="item.username"
                              :value="item.userId">
                      </el-option>
                    </el-select>
                    </span>
               </div>
                <button class='button is-primary' @click="doSearch">搜索</button>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>日期</th>
                            <th>姓名</th>
                            <th v-for="item in 24">{{item-1}}~{{item}}</th>
                            <th>汇总在线时间</th>
                            <th>汇总离线时间</th>
                            <th>今日最早上线时间</th>
                            <th>今日最晚下线时间</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in list">
                            <td>{{item.date}}</td>
                            <td>{{item.username}}</td>
                            <th v-for="item in item.timeline">{{item}}</th>
                            <td>{{item.onlineTime}}</td>
                            <td>{{item.offlineTime}}</td>
                            <td>{{item.firstOnlineTime}}</td>
                            <td>{{item.lastOnlineTime}}</td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import { formatDate } from 'UTILS/date';
    export default {
        data(){
            return {
                categoryList: [
                    {
                        categoryName:"穿衣助手平台",
                        type:0,
                    },
                    {
                        categoryName:"第三方导购",
                        type:1,
                    },
                    {
                        categoryName:"ICY App",
                        type:2,
                    },
                ],
                activeIndex:0,
                list:[],
                count:0,// 有了数据改成0
                search:{
                    startTime:'',
                    endTime:'',
                    page:1,
                    pageSize:20,
                    type:0,
                    userId:null,
                },
                csList:[],
                adminUserId:null,

            }
        },
        mounted(){
            this.getList(this.search);
        },
        methods:{
            handleCurrentChange(value){
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getList(this.search);
                }
            },
            /**
             * 获取初始化数据列表；
             */
            getList(_params){
                let params = {
                    page: _params.page,
                    pageSize: _params.pageSize,
                    type: _params.type,
                }
                if(_params.userId){
                    params.userId=_params.userId
                }
                if(_params.startTime){
                    params.startTime=formatDate(new Date(_params.startTime).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                if(_params.endTime){
                    params.endTime=formatDate(new Date(_params.endTime).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                console.log(params)
                HttpRequest.get('/admin.php?method=feedback.getServiceStat', params).then(response => {
                    if (response) {
                        this.list = _.toArray(response.data.list);
                        this.count = response.data.count;
//                        this.search.type=response.data.type;

                    }
                });
                HttpRequest.post('/admin.php?method=agencyoperation.getAdminInfo').then(response => {
                    this.csList = _.toArray(response.data)

                });

            },
            doSearch() {
                this.getList(this.search)
            },
            onTabClick(type, index) {
                this.search.page = 1;
                this.activeIndex = index;
                this.search.type=type;
                this.getList(this.search)
            },

        },

    }
</script>
<style lang="less" scoped>
    .margin-right{
        margin-right: 50px;
    }
    .red-color{
        color:red;
    }
    .blue-color{
        color:blue;
        cursor: pointer;
    }
    .like-tabs {
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
    }
    .like-button {
        padding-left: 10px;
    }
    .likeTabItem{
        line-height: 60px;
        height: 50px;
        font-size: 16px;
        padding: 0 4px;
        box-sizing: border-box;

    }
    .likeTabItem :hover {
        color: #ae0fff
    }
    .active {
        border-bottom: 1px solid #337ab7;
    }
    .search-component {
        display: flex;

        label {
            margin: 5px 5px 0 0;
        }
        .button {
            margin-left: 5px;
        }
    }
    .margin-r{
        margin-right: 41px;
    }
    .btn{
        width:40px;
        height:20px;
        border-radius: 10px;
        background-color: #13CE66;
        border-width: 1px;
        .point{
            float:right;
            width:20px;
            height:20px;
            border-width: 1px;

            border-radius: 100%;
            background-color: #fff;
        }
    }
    .disableBtn{
        width:40px;
        height:20px;
        border-radius: 10px;
        background-color: #cccccc;
        border-width: 1px;
        .point{
            float:left;
            width:20px;
            height:20px;
            border-width: 1px;

            border-radius: 100%;
            background-color: #fff;
        }
    }
</style>
